module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"please-wait":"Please wait..."}}')
  delete Component.options._Ctor
}
